export default {
    props: {
        seriesDefaultsArea: {
            type: Object,
            kComposite: 'seriesDefaults.area'
        }, 
        seriesDefaultsBar: {
            type: Object,
            kComposite: 'seriesDefaults.bar'
        }, 
        seriesDefaultsBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.border.color'
        }, 
        seriesDefaultsBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.border.dashType'
        }, 
        seriesDefaultsBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.border.width'
        }, 
        seriesDefaultsColumn: {
            type: Object,
            kComposite: 'seriesDefaults.column'
        }, 
        seriesDefaultsGap: {
            type: Number,
            kComposite: 'seriesDefaults.gap'
        }, 
        seriesDefaultsLabelsBackground: {
            type: String,
            kComposite: 'seriesDefaults.labels.background'
        }, 
        seriesDefaultsLabelsBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.border.color'
        }, 
        seriesDefaultsLabelsBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.labels.border.dashType'
        }, 
        seriesDefaultsLabelsBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.labels.border.width'
        }, 
        seriesDefaultsLabelsColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.color'
        }, 
        seriesDefaultsLabelsFont: {
            type: String,
            kComposite: 'seriesDefaults.labels.font'
        }, 
        seriesDefaultsLabelsFormat: {
            type: String,
            kComposite: 'seriesDefaults.labels.format'
        }, 
        seriesDefaultsLabelsMargin: {
            type: Number | Object,
            kComposite: 'seriesDefaults.labels.margin'
        }, 
        seriesDefaultsLabelsPadding: {
            type: Number | Object,
            kComposite: 'seriesDefaults.labels.padding'
        }, 
        seriesDefaultsLabelsTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.labels.template'
        }, 
        seriesDefaultsLabelsVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.labels.visible'
        }, 
        seriesDefaultsLine: {
            type: Object,
            kComposite: 'seriesDefaults.line'
        }, 
        seriesDefaultsOverlay: {
            type: Object,
            kComposite: 'seriesDefaults.overlay'
        }, 
        seriesDefaultsPie: {
            type: Object,
            kComposite: 'seriesDefaults.pie'
        }, 
        seriesDefaultsSpacing: {
            type: Number,
            kComposite: 'seriesDefaults.spacing'
        }, 
        seriesDefaultsStack: {
            type: Boolean,
            kComposite: 'seriesDefaults.stack'
        }, 
        seriesDefaultsStackType: {
            type: String,
            kComposite: 'seriesDefaults.stack.type'
        }, 
        seriesDefaultsType: {
            type: String,
            kComposite: 'seriesDefaults.type'
        }, 
        seriesDefaultsTooltipBackground: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.background'
        }, 
        seriesDefaultsTooltipBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.border.color'
        }, 
        seriesDefaultsTooltipBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.border.width'
        }, 
        seriesDefaultsTooltipColor: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.color'
        }, 
        seriesDefaultsTooltipFont: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.font'
        }, 
        seriesDefaultsTooltipFormat: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.format'
        }, 
        seriesDefaultsTooltipPadding: {
            type: Number | Object,
            kComposite: 'seriesDefaults.tooltip.padding'
        }, 
        seriesDefaultsTooltipTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.tooltip.template'
        }, 
        seriesDefaultsTooltipVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.tooltip.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/SeriesDefaults.js